module.exports = __webpack_public_path__ + "static/media/wordpress_development.4933cda2.svg";